import { render, staticRenderFns } from "./ShareProofVideoModal.vue?vue&type=template&id=6b8e2db6"
import script from "./ShareProofVideoModal.vue?vue&type=script&lang=js"
export * from "./ShareProofVideoModal.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports